<template>
  <v-layout column fluid>
    <v-flex>
      <HeaderBar>
        <v-icon slot="icon">settings</v-icon>
        Holidays
        <template slot="buttons">
          <router-link :to="{ name: 'settingsIndex' }">Back to All Settings</router-link>
        </template>
      </HeaderBar>
    </v-flex>

    <v-flex>
      <h2 class="display-1 mb-4">Holidays:</h2>
    </v-flex>
    <v-flex v-if="gettingHolidays || deletingHoliday">
      <v-progress-circular indeterminate>
      </v-progress-circular>
    </v-flex>
    <v-flex v-else class="mb-4">
      <div v-if="!holidays || holidays.length < 1">
        No holidays yet...
      </div>
      <div v-else>
        <ul>
          <li
            v-for="holiday in orderedHolidays"
            :key="holiday.id"
            class="holiday"
          >
            {{ holiday.date | moment("dddd, MMMM Do YYYY") }}
            <span v-if="user.bohOrHigher && !deletingHoliday" class="holiday-remove">
              <a href="#" @click.prevent="deleteHoliday(holiday.id)" color="error" class="red--text">
                <v-icon color="red">
                  cancel
                </v-icon>
              </a>
            </span>
          </li>
        </ul>
      </div>
    </v-flex>
    <v-flex v-if="user.bohOrHigher">
      <v-layout row>
        <v-flex shrink class="mr-2">
          <v-menu
            ref="holidayDateMenu"
            v-model="holidayDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template slot="activator" slot-scope="{ on }">
              <v-text-field
                label="Start Date"
                format="dddd, MM DD YYYY"
                @change="value => newHolidayDate = value"
                :value="dateFormatted(newHolidayDate)"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="newHolidayDate"
              @input="holidayDateMenu = false"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-btn @click="createHoliday" color="success" :disabled="creatingHoliday" :loading="creatingHoliday">
          <v-icon left>
            add
          </v-icon>
          Add Holiday
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    orderedHolidays: function () {
      return this.holidays.slice()
        .sort((a,b) => new Date(a.date) - new Date(b.date))
    },
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      holidays: [],
      gettingHolidays: false,
      deletingHoliday: false,
      deletingHolidayId: null,
      creatingHoliday: false,
      holidayDateMenu: false,
      newHolidayDate: this.$moment().format("YYYY-MM-DD"),
    }
  },
  methods: {
    setUp () {
      this.getHolidays()
    },
    createHoliday () {
      this.creatingHoliday = true
      this.$store.dispatch('holidays/create', { date: this.newHolidayDate })
        .then(r => {
          this.holidays.push(r)
          this.$store.dispatch('global/showSnackbarSuccess', { message: "Holiday created!" })
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('global/showSnackbarError', { message: 'There was something wrong with that holiday. Is it a duplicate?' })
        })
        .finally(r => {
          this.creatingHoliday = false
        })
    },
    dateFormatted: function (date) {
      return this.$moment(date).format("dddd, MMMM Do YYYY")
    },
    getHolidays () {
      this.gettingHolidays = true
      this.$store.dispatch('holidays/getAll')
      .then(r => {
        this.holidays = r
      })
      .catch(error => {
        console.log(error)
      })
      .finally(r => {
        this.gettingHolidays = false
      })
    },
    deleteHoliday (id) {
      this.deletingHoliday = true
      this.deletingHolidyId = id
      this.$store.dispatch('holidays/delete', id)
      .then(r => {
        this.holidays = [
          ...this.holidays.filter(h => h.id !== id)
        ]
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Holiday deleted!" })
      })
      .catch(error => {
        this.$store.dispatch('global/showSnackbarError', { message: "Couldn't delete that holiday" })
      })
      .finally(r => {
        this.deletingHoliday = false
        this.deletingHolidayId = null
      })
    },
  },
}
</script>

<style scoped>
.holiday-remove {
  visibility: hidden;
  animation: none;
}

.holiday:hover .holiday-remove {
  visibility: visible;
  display: inline-block;
}
</style>
